import "./section6.scss";

import { Card, Carousel, Image } from "react-bootstrap";
import { RightArrowIcon } from "src/assets";
import { Button, DynamicCard } from "src/ui/widgets";

import { ImageProps, useSection6 } from "./section6.hook";
import { DynamicCardProps } from "src/types";

export const Section6 = () => {
  const { t, groupedItems } = useSection6();

  const CarouselComponent = (
    <Carousel
      controls={false}
      indicators={true}
      interval={4000}
      className="carousel-outside slow-transition"
    >
      {groupedItems.map((item: DynamicCardProps[], index: number) => (
        <Carousel.Item key={index}>
          <div className="d-md-flex">
            {item.map((item: DynamicCardProps, index: number) => {
              const isThird = (index + 1) % 3 === 0;

              return (
                <div
                  key={item.carouselCode}
                  className={`card-wrapper ${isThird && "m-0"}`}
                >
                  <DynamicCard {...item} />
                </div>
              );
            })}
          </div>
        </Carousel.Item>
      ))}
    </Carousel>
  );

  return (
    <div>
      <div className="font-48-light c-292929">
        {t("landing.section6.title")}
      </div>
      <div className="mt-2 d-flex align-items-center text-left font-18-roman c-646464 mb-5">
        {t("landing.section6.subtitle")}
      </div>
      {CarouselComponent}
    </div>
  );
};
